'use client';

import { SlotEquivalentLinksItem } from '../Base/SlotEquivalentLinks.Item.client';
import { useLocaleSwitch } from '../../shared/useLocaleSwitch';

export const LocaleSwitchLink = () => {
  const { label, href, targetLanguage, switchLocale, isSwitching } = useLocaleSwitch();
  return (
    <SlotEquivalentLinksItem
      ariaLabel={label}
      href={href ?? '#'}
      onClick={switchLocale}
      language={targetLanguage}
      isBusy={isSwitching}
    >
      <span className="icon-emp-language-switch size-4" aria-hidden />
      <span className="hyphens-auto">{label}</span>
    </SlotEquivalentLinksItem>
  );
};
